import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const PlatformsWrapperStyle = styled.div`
  width: 100%;
  display: block;
  border-radius: 5px;
`

export const PlatformContainer = styled.div`
  display: flex;
  padding: 20px 16px 16px 13px;
  background-color: ${colors.white};
  margin-bottom: 9px;
  border-radius: 4px;
  position: relative;

  @media ${device.mobileMin} {
    padding: 20px 24px 24px 24px;
    margin-bottom: 16px;
  }
`

export const WrapperForToggleSwitchAntd = styled.div`
  margin-right: 16px;
  padding-top: 4px;
  @media ${device.mobileMin} {
    margin-right: 24px;
  }
`

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 24px;
  @media ${device.mobileMin} {
    margin-bottom: 16px;
  }
`

export const Platform = styled.div`
  display: flex;
  flex-direction: column;
`

export const PlatformIcon = styled.div`
  align-self: center;
  display: flex;
  & img {
    min-height: 24px;
    min-width: 24px;
    height: 24px;
    width: 24px;
    margin-right: 8px;
  }
`
export const PageSubHeaderWrapper = styled.div`
  margin-bottom: 0px;
`
export const AddedSuccessfully = styled.div`
  display: none;
  color: ${colors.greyTextWhiteBg};

  @media ${device.mobileMin} {
    display: block;
    padding-top: 0px;
  }
`
export const AddTrackItem = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  color: ${colors.mainText};
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0px;
  }
`

export const AddTrackInfo = styled.div`
  display: flex;

  @media ${device.mobileMin} {
    display: flex;
    flex-direction: row;
    flex: 1 1;
    align-items: center;
  }
`

export const AddTrackUrl = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 4px;
  margin-right: 16px;
`

export const AddTrackInfoDescr = styled.div`
  padding: 0px;
  margin-bottom: 0px;
`

export const AddTrackInfoTitle = styled.div`
  font-weight: 600;
  line-height: 21px;
`
